import { Logout, Menu, Close } from '@mui/icons-material';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../config/AuthContext';
import { logo } from '../config/config';

const Header = () => {
     const { user, handleLogout } = useAuth();
     const [menuOpen, setMenuOpen] = useState(false);

     const toggleMenu = () => setMenuOpen(!menuOpen);

     return (
          <header className="header-app heading-font">
               <div className="header-app-container">
                    <Link to="/" className="forge-logo">
                    <img src={logo} alt="Logo" />
                    </Link>

                    {/* Desktop Links */}
                    <div className="desktop-links">
                         <Link to="/about">About</Link>
                         <Link to="/explore">Explore</Link>
                         <Link to="/overview">Overview</Link>
                         <Link to="/submit" className="forge-btn-sm">Submit Idea</Link>
                         {user ? (
                              <button onClick={handleLogout} className='logout-btn'>
                                   <Logout /> Logout
                              </button>
                         ) : (
                              <Link to="/login" className="logout-btn">Login</Link>
                         )}
                    </div>

                    {/* Mobile Hamburger */}
                    <button className="mobile-toggle" onClick={toggleMenu}>
                         {menuOpen ? <Close /> : <Menu />}
                    </button>
               </div>

               {/* Mobile Overlay */}
               <div className={`mobile-overlay ${menuOpen ? 'open' : ''}`}>
                    <nav className="overlay-links">
                         <button className="close-btn" onClick={toggleMenu}> <Close /> </button>
                         <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
                         <Link to="/explore" onClick={() => setMenuOpen(false)}>Explore</Link>
                         <Link to="/overview" onClick={() => setMenuOpen(false)}>Overview</Link>
                         <Link to="/submit" className="forge-btn-sm" onClick={() => setMenuOpen(false)}>Submit Idea</Link>
                         {user ? (
                              <button
                                   onClick={() => { handleLogout(); setMenuOpen(false); }}
                                   className="logout-btn"
                              >
                                   <Logout /> Logout
                              </button>
                         ) : (
                              <Link to="/login" className="logout-btn" onClick={() => setMenuOpen(false)}>Login</Link>
                         )}
                    </nav>
               </div>
          </header>
     );
};

export default Header;